(function($){

    function throttle(func, limit) {
        var inThrottle
        return function() {
          var args = arguments
          var context = this
          if (!inThrottle) {
            func.apply(context, args)
            inThrottle = true
            setTimeout(function(){ inThrottle = false, limit})
          }
        }
      }

    $(document).ready(function() {
        var play_btn = document.querySelector('#main-video')
        if (!play_btn) return

        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = function() {
            var id = play_btn.getAttribute('data-youtube-id')

            var vid_wrap = document.createElement('div'),
                vid_cont = document.createElement('div'),
                close_vid = document.createElement('div')
            var player,
                player_instance
            vid_wrap.classList.add('video-wrap')
            vid_cont.classList.add('video-container')
            close_vid.classList.add('close-video')
            vid_wrap.appendChild(vid_cont)
            vid_wrap.appendChild(close_vid)
            vid_wrap.classList.add('video-wrap')
            document.querySelector('.slick-current').appendChild(vid_wrap)

            play_btn.addEventListener('click', function() {
                play_btn.classList.add('hidden')
                vid_wrap.classList.add('visible')
                player = new YT.Player(vid_cont, {
                    videoId: id,
                    playerVars: {
                        playsinline: 1,
                        allowsInlineMediaPlayback: true,
                    },
                    events: {
                        'onReady': function(e) {
                            handle_resize()
                            close_vid.classList.add('visible')
                            if (player_instance === undefined) {
                                player_instance = e.target
                                player_instance.a.ref = player
                            }
                            player_instance.mute()
                            player_instance.playVideo()
                            player_instance.unMute()
                        },
                        'onStateChange': function() {}
                    }
                });
                function handle_resize() {
                    var h = vid_wrap.getBoundingClientRect().height,
                        ww = window.innerWidth
                    var w = h*1.77
                    if (w > ww) {
                        w = window.innerWidth
                    }
                    vid_wrap.style.width = w + "px"
                }
                window.addEventListener('resize', throttle(handle_resize, 100))
            })
            close_vid.addEventListener('click', function() {
                player_instance.pauseVideo()
                play_btn.classList.remove('hidden')
                vid_wrap.classList.remove('visible')
            })
        }
    });
})(jQuery);